import { LocalDate } from '@js-joda/core';

import { FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, DateRangePickerLegacy } from '@dreryk/react-components';
import { Range } from '@dreryk/watermelon';

import { entitlementStatementsTranslationKeys } from '../../translations';

type GrantingDateFieldProps = FieldControllerProps<'grantingDate', Range<LocalDate> | null> & ClassNameProp;

export const GrantingDateField = (props: GrantingDateFieldProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: true,
   });

   return (
      <DateRangePickerLegacy
         controller={controller}
         required
         label={entitlementStatementsTranslationKeys.createModal.grantingDate}
         testId={'validityDateRange'}
      />
   );
};
